import {
  CARD,
  VIDEO,
  VideoDefinition,
  CardDefinition,
  CAROUSEL,
  CarouselDefinition,
  TEXT,
  LAYOUT_LIST
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia14: Translator = sequence => {
  const cards: CardDefinition[] = [];
  const header: { title: string; subtitle: string; icon: string } = {
    title: '',
    subtitle: '',
    icon: ''
  };

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Text':
        header.title = item.title || '';
        header.subtitle = item.subtitle || '';
        header.icon = item.icon || '';
        break;
      case 'Card':
        cards.push({
          type: CARD,
          id: item.id,
          values: {
            clearStyles: 'xs',
            height: { _: '70%', sm: '100%' },
            width: { _: '300px', sm: '100%' },
            padding: { _: '10px 0 0 0', sm: '0px' }
          },
          items: [
            {
              id: item.id,
              type: VIDEO,
              values: {
                videoId: item?.videos?.[0]?.id,
                blocking: true,
                isolated: true,
                mediaUrl:
                  item.videos && item.videos.length
                    ? [{ src: item.videos[0].mediaUrl!, type: 'video/mp4' }]
                    : null,
                subtitlesUrl:
                  item.videos && item.videos.length
                    ? item.videos[0].subtitlesUrl
                    : null,
                autoPlay: false,
                showProgress: true,
                showPlayButton: true,
                videoContainerStyles: {
                  width: '300px',
                  height: '500px',
                  position: 'relative',
                  borderRadius: '20px'
                }
              },
              items: []
            } as VideoDefinition
          ]
        });
    }
    return null;
  });

  root.items.push({
    id: sequence.id,
    type: LAYOUT_LIST,
    values: {
      align: 'center',
      padded: true
    },
    items: [
      {
        type: TEXT,
        id: 'title',
        items: [],
        values: {
          value: header.title,
          variant: 'heading1'
        }
      },
      {
        type: TEXT,
        id: 'subtitle',
        items: [],
        values: {
          value: header.subtitle,
          variant: 'sub_heading',
          icon: header?.icon || ''
        }
      },
      {
        type: CAROUSEL,
        id: `${sequence.id}.carousel`,
        values: {
          variant: { _: 'horizontal', md: 'dynamic' }
        },
        items: cards
      } as CarouselDefinition
    ]
  });

  return root;
};
